export default {
  "/promotion/report": {
    module: "promotion",
    menu: "report"
  },
  "/mkt/analize": {
    module: "promotion",
    menu: "report"
  },
  "/salesops": {
    module: "promotion",
    menu: "report"
  }
};
